import {Component} from 'preact';
import {playIcon} from '../../../constants/icons';
import {getCurrentTranslation} from '../../../../i18n/I18nResolver';

export default class MapPlayButton extends Component {
    onTogglePlay = () => {
        const {togglePause} = this.props;
        if (togglePause) {
            togglePause(false);
        }
    };

    render() {
        const translations = getCurrentTranslation();
        const label = translations.mapControls.animationPlay;

        return (
            <button
                className="map-controls__btn"
                onClick={this.onTogglePlay}
                aria-label={label}
                aria-live="assertive"
            >
                {{...playIcon, props: {...playIcon.props, alt: label}}}
            </button>
        );
    }
}
